export const baseURL = "/renewal-suites-comparison";
export const detailedBenefitsComparisonURL = `${baseURL}/detailed-benefits-comparison`;
export const detailedCostsComparisonURL = `${baseURL}/detailed-costs-comparison`;
